import React, { useEffect } from "react";
import CheckedCircle from "assets/svgs/checkedCircle.svg";
import TrashIcon from "assets/svgs/trashIcon.svg";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';
import { TooltipItem } from "shared/components";

const StaffPoolListItem = (props) => {
  const { t } = useTranslation();
  const { firstName, lastName, email, status, id } = props.staff;

  useEffect(() => {
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach(
      (el) => bootstrap.Popover.getOrCreateInstance(el).enable()
    );
  }, []);

  const inviteStatus = {
    pending: "Invited",
    declined: "Declined",
    active: "Active",
  };

  const filteredStatus = status ?? "active";
  const isStatusActive = Boolean(status);
  const statusClass = !isStatusActive ? "active" : "completed";
  const removeButtonText = status === "pending" ? "Cancel Invite" : "Remove";

  return (
    <div className="staff-pool-list-item">
      <div className="staff-name">
        {" "}
        <TooltipItem item={`${lastName}, ${firstName}`} />
      </div>
      <div className="staff-email">
        {" "}
        <TooltipItem item={email} />
      </div>
      <div
        className={`status ${statusClass}`}
        data-bs-toggle="popover"
        data-bs-placement="top"
        data-bs-trigger="hover"
        data-bs-boundary="window"
        data-bs-html
        data-bs-template='<div class="popover staff-pool-tooltip" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>'
        data-bs-content={`<div>${t(
          `staffAndRoomsManagement.staffPool.${filteredStatus}`
        )}</div>`}
      >
        {!isStatusActive && <CheckedCircle />}
        {inviteStatus[filteredStatus]}
      </div>
      <div className="staff-remove">
        <div
          onClick={() => {
            props.handleOpenModal(status, id);
          }}
        >
          {removeButtonText}
        </div>
        <TrashIcon />
      </div>
    </div>
  );
};

export default StaffPoolListItem;

StaffPoolListItem.propTypes = {
  staff: PropTypes.shape({
    email: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    status: PropTypes.string,
    id: PropTypes.number.isRequired,
  }),
  handleOpenModal: PropTypes.func.isRequired,
};
